import React from "react";
import { Tabs } from "antd";
import UploadedOrdersTab from "./Tabs/UploadedOrdersTab.js";
import OpenedOrdersTab from "./Tabs/OpenedOrdersTab.js";
import BestBuyOrderTab from "./Tabs/BestBuyOrderTab.js";
import CompletedOrdersTab from "./Tabs/CompletedOrdersTab.js";

const OrdersAutomation = () => {
    return (
        <div style={{ padding: 24 }}>
            <Tabs
                defaultActiveKey="3"
                destroyInactiveTabPane={false}
                items={[
                    {
                        key: "1",
                        label: "Completed Orders",
                     
                        children: <CompletedOrdersTab />,
                    },
                    {
                        key: "2",
                        label: "Upload Orders",
                        children: <UploadedOrdersTab />,
                    },
                    {
                        key: "3",
                        label: "Opened Orders",
                        children: <OpenedOrdersTab />,
                    },
                    {
                        key: "4",
                        label: "Best Buy Order",
                        children: <BestBuyOrderTab />,
                    },
                ]}
            />
        </div>
    );
};

export default OrdersAutomation;